import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

import { CashAppLogoMark } from '../../../../../ucl/themes/icons';
import { IBraintreeButton } from '../types';

// todo refactor this to use refs and avoid ID all-together
export const CASHAPP_BUTTON_ID = 'cashapp-button';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  height: '44px',
  accessible: true,
  accessibilityRole: 'button',
  accessibilityLabel: 'Cash App Pay',
  _text: {
    fontSize: 'xl',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  backgroundColor: '#000000',
  padding: 4,
});

export const CashAppStyledButton: React.FC<IBraintreeButton> = ({
  onPress,
  isLoading,
  id,
}: IBraintreeButton) => {
  return (
    <StyledButton fullWidth isLoading={isLoading} onPress={onPress} id={CASHAPP_BUTTON_ID}>
      {isLoading ? null : <CashAppLogoMark maxHeight={'20px'}></CashAppLogoMark>}
    </StyledButton>
  );
};
